import ImgBox from './src/ImgBox'

ImgBox.install = function (Vue) {
    Vue.component(ImgBox.name, ImgBox);
};

export default ImgBox;